module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Compiled-file-5e468075eff62ecba938ad301332176a.svg";